module.exports = __webpack_public_path__ + "static/img/logo-notext-bw.2990dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-notext-bw.png
// module id = dXIa
// module chunks = 1